import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "reactstrap";
import Select from "react-select";
import { useFormContext, Controller } from "react-hook-form";
import "./ShipInfo.scss";
import LocationProvider from "./providerLocation";
import { checkVAT } from "../../helpers/check-vat";
import toastr from "toastr";
import { INVOICE_TYPE, INVOICE_TYPE_ARCHIVE_NAME, INVOICE_TYPE_NAME, INVOICE_TYPE_NEED_VAT_INFO, VAT_PERCENTS } from "../../utils";

const INVOICE_TYPE_OPTIONS = Object.entries(INVOICE_TYPE_NAME).map(([key, value]) => ({
  name: value,
  value: key
}))


const ShipInfo = (props) => {
  const { status, idOder, handleChangePhone, orderData, isWarningChangeVATAddress, legacyAddressText } = props;
  const {
    register,
    control,
    getValues,
    setValue,
    watch,
    formState: { errors, isDirty },
  } = useFormContext();
  const codeVATRef = useRef(null);
  const [isLoadingCodeVAT, setIsLoadingCodeVAT] = useState(false);
  const [isShowNoteInvoice, setIsShowNoteInvoice] = useState(INVOICE_TYPE_NEED_VAT_INFO.includes(getValues().invoiceType));
  const invoiceType = watch('invoiceType')
  useEffect(() => {
    const needVATInfo = INVOICE_TYPE_NEED_VAT_INFO.includes(getValues().invoiceType)
    setIsShowNoteInvoice(needVATInfo)
    if (!isDirty) {
      return;
    }
    if (!needVATInfo) {
      setValue('codeVAT', '')
      setValue('companyNameVAT', '')
      setValue('addressVAT', '')
      setValue('emailReceivedVAT', '')
    }
  }, [invoiceType, isDirty])


  // useEffect(() => {
  //   console.log(getValues().district)
  // }, [watch('district')])

  const onFindCodeVAT = (codeVAT) => {
    const regex = /^\d{10}(-\d{3})?$/;
    if (!codeVAT || !regex.test(codeVAT)) {
      setValue('companyNameVAT', null)
      setValue('addressVAT', null)
      return;
    }

    setIsLoadingCodeVAT(true);
    clearTimeout(codeVATRef.current);
    codeVATRef.current = setTimeout(() => {
      checkVAT(codeVAT)
        .then(({
          data, error
        }) => {
          if (error) {
            toastr.error(error)
            setValue('companyNameVAT', null)
            setValue('addressVAT', null)
            return;
          }
          setValue('companyNameVAT', data.companyNameVAT)
          setValue('addressVAT', data.addressVAT)
        }).finally(() => {
          setIsLoadingCodeVAT(false);
        })
        .catch((error) => {
          console.log(error)
        })
    }, 500)
  }

  return (
    <div className="ship-info">
      <h5>Thông tin đơn hàng</h5>
      <Row className="mt-3">
        <Col col={12} md={6}>
          <Row className="mb-3 justify-content-between">
            <label className="col-md-4 col-form-label">Tên người nhận</label>
            <div className="col-md-7">
              <input
                className={`table-product_input ${errors.name ? "table-product_input-error" : ""
                  }`}
                placeholder="Tên người nhận"
                disabled={status === "INFO"}
                {...register("name", {
                  required: "Tên người dùng không được để trống",
                })}
              />
              {errors.name && <p className="p-errors">{errors.name.message}</p>}
            </div>
          </Row>
          <Row className="mb-3 justify-content-between">
            <label className="col-md-4 col-form-label">Số điện thoại</label>
            <div className="col-md-7">
              <Controller
                name="phone"
                control={control}
                rules={{
                  required: "Số điện thoại không được để trống",
                  pattern: {
                    value: /^[0](?:\d){9}$/,
                    message: "Số điện thoại không đúng định dạng",
                  },
                }}
                render={({ field }) => (
                  <>
                    <input
                      disabled={status === "INFO"}
                      className={`table-product_input ${errors.phone ? "table-product_input-error" : ""
                        }`}
                      value={field.value}
                      onChange={(e) => {
                        const value = e.target?.value?.replace(/[^0-9]/g, "")
                        field.onChange(value);
                        handleChangePhone(value);
                      }}
                      placeholder="Số điện thoại"
                    />
                    {errors.phone && (
                      <p className="p-errors">{errors.phone.message}</p>
                    )}
                  </>
                )}
              />
            </div>
          </Row>
          <Row className="mb-3 justify-content-between">
            <label className="col-md-4 col-form-label">Email</label>
            <div className="col-md-7">
              <Controller
                control={control}
                name="email"
                rules={{
                  required: "Email không được để trống"
                }}
                render={({ field: { onChange, value } }) => (
                  <input
                    disabled={status === "INFO"}
                    type="text"
                    className={`table-product_input ${errors.email ? "table-product_input-error" : ""}`}
                    placeholder="Email"
                    value={value}
                    onChange={(e) => onChange(e.target.value?.toLowerCase()?.trim() || '')}
                  />
                )}
              />
              {errors.email && (
                <p className="p-errors">{errors.email.message}</p>
              )}
            </div>
          </Row>
          {
            !idOder && <Row className="mb-3 justify-content-between">
              <label className="col-md-4 col-form-label">Gửi Email đơn hàng</label>
              <div className="col-md-7">
                <input
                  type="checkbox"
                  style={{ cursor: "pointer" }}
                  disabled={status === "INFO"}
                  placeholder="Gửi email"
                  {...register("isSendMail")}
                />
                {errors.isSendMail && (
                  <p className="p-errors">{errors.isSendMail.message}</p>
                )}
              </div>
            </Row>
          }

          <Row className="justify-content-between">
            <label className="col-md-4 col-form-label">Ghi chú</label>
            <div className="col-md-7">
              <textarea
                style={{ height: '100px' }}
                disabled={status === "INFO"}
                className="table-product_input"
                placeholder="Ghi chú"
                {...register("note")}
              />
            </div>
          </Row>
          <Row className="justify-content-between">
            <label className="col-md-4 col-form-label">Xuất hoá đơn</label>
            <div className="col-md-7">
              {!!invoiceType && INVOICE_TYPE_ARCHIVE_NAME[invoiceType] && <div className="text-warning" >
                <label><input
                  disabled={true}
                  style={{ marginRight: '10px' }}
                  type="radio"
                  value={invoiceType} />(Không còn khả dụng){INVOICE_TYPE_ARCHIVE_NAME[invoiceType]}</label>
              </div>}
              {INVOICE_TYPE_OPTIONS.map(data =>
                <div key={data.value}>
                  <label><input
                    disabled={status === "INFO"}
                    {...register("invoiceType", {
                      required: 'Vui lòng chọn loại xuất hoá đơn'
                    })}
                    style={{ marginRight: '10px' }}
                    type="radio"
                    value={data.value} />{data.name}</label>
                </div>
              )}
              {errors.invoiceType && (
                <p className="p-errors">{errors.invoiceType.message}</p>
              )}
            </div>
          </Row>
          {isShowNoteInvoice ?
            <>
              <Row className="justify-content-between">
                <label className="col-md-4 col-form-label">Mã số thuế</label>
                <div className="col-md-7">
                  <Controller
                    control={control}
                    name="codeVAT"
                    render={({ field: { onChange, value } }) => (
                      <input
                        disabled={status === "INFO"}
                        className="table-product_input"
                        placeholder="Mã số thuế"
                        value={value}
                        onChange={(e) => {
                          const value = e.target.value?.replace(/[^0-9\-]/g, "") || '';
                          onChange(value || '')
                          onFindCodeVAT(value || '')
                        }}
                      />
                    )}
                  />
                </div>
              </Row>
              <Row className="justify-content-between mt-2">
                <label className="col-md-4 col-form-label">Tên công ty</label>
                <div className={`col-md-7`}>
                  <textarea
                    style={{ minHeight: '50px' }}
                    className={`table-product_input ${isWarningChangeVATAddress ? 'text-danger' : ''}`}
                    placeholder={isLoadingCodeVAT ? 'Đang tìm kiếm...' : 'Hệ thống tự lấy theo mã số thuế (Quý khách có thể chỉnh sửa)'}
                    {...register("companyNameVAT")}
                  />
                </div>
              </Row>
              <Row className="justify-content-between mt-2">
                <label className="col-md-4 col-form-label">Địa chỉ hoá đơn</label>
                <div className={`col-md-7 d-flex`}>
                  <textarea

                    style={{ minHeight: '50px' }}
                    className={`table-product_input ${isWarningChangeVATAddress ? 'text-danger' : ''}`}
                    placeholder={isLoadingCodeVAT ? 'Đang tìm kiếm...' : 'Hệ thống tự lấy theo mã số thuế (Quý khách có thể chỉnh sửa)'}
                    {...register("addressVAT")}
                  />
                </div>
              </Row>


              <Row className="justify-content-between mt-2">
                <label className="col-md-4 col-form-label">Email nhận hoá đơn</label>
                <div className="col-md-7">
                  <Controller
                    control={control}
                    name="emailReceivedVAT"
                    render={({ field: { onChange, value } }) => (
                      <input
                        disabled={status === "INFO"}
                        type="text"
                        className="table-product_input"
                        placeholder="Email nhận hoá đơn"
                        value={value}
                        onChange={(e) => onChange(e.target.value?.toLowerCase()?.trim() || '')}
                      />
                    )}
                  />
                </div>
              </Row>
            </>
            : ''}

        </Col>
        <Col col={12} md={6}>
          <LocationProvider>
            {({ provinceOptions, wardOptions }) => (
              <>
                {legacyAddressText ? (
                  <Row className="mb-3">
                    <div className="text-warning">
                      Địa chỉ cũ theo đơn vị hành chính trước đây: {legacyAddressText}. Vui lòng chọn lại Thành phố / Tỉnh và Xã / Phường mới.
                    </div>
                  </Row>
                ) : null}
                <Row className="mb-3 justify-content-between">
                  <label className="col-md-4 col-form-label">
                    Thành phố / Tỉnh
                  </label>
                  <div className="col-md-7">
                    <Controller
                      name="province"
                      control={control}
                      rules={{
                        required: "Thành phố / Tỉnh không được để trống",
                      }}
                      render={({ field: { onChange, ...field } }) => (
                        <>
                          <Select
                            {...field}
                            styles={{
                              menuList: (baseStyles, state) => ({
                                ...baseStyles,
                                height: 150
                              }),
                            }}
                            onChange={(value) => {
                              onChange(value);
                              setValue('ward', null)
                            }}
                            placeholder="Thành phố / Tỉnh"
                            options={provinceOptions}
                            isDisabled={status === "INFO"}
                            classNamePrefix="select2-selection "
                          />
                          {errors.province && (
                            <p className="p-errors">
                              {errors.province.message}
                            </p>
                          )}
                        </>
                      )}
                    />
                  </div>
                </Row>
                <Row className="mb-3 justify-content-between">
                  <label className="col-md-4 col-form-label">Xã / Phường</label>
                  <div className="col-md-7">
                    <Controller
                      name="ward"
                      control={control}
                      rules={{ required: "Xã / Phường không được để trống" }}
                      render={({ field }) => (
                        <>
                          <Select
                            {...field}
                            styles={{
                              menuList: (baseStyles, state) => ({
                                ...baseStyles,
                                height: 150
                              }),
                            }}
                            placeholder="Xã / Phường"
                            options={wardOptions}
                            isDisabled={status === "INFO"}
                            classNamePrefix="select2-selection "
                          />
                          {errors.ward && (
                            <p className="p-errors">{errors.ward.message}</p>
                          )}
                        </>
                      )}
                    />
                  </div>
                </Row>
              </>
            )}
          </LocationProvider>
          <Row className="mb-3 justify-content-between">
            <label className="col-md-4 col-form-label">Địa chỉ cụ thể</label>
            <div className="col-md-7">
              <input
                disabled={status === "INFO"}
                className={`table-product_input ${errors.email ? "table-product_input-error" : ""
                  }`}
                placeholder="Địa chỉ cụ thể"
                {...register("street", {
                  required: "Địa chỉ không được để trống",
                })}
              />
              {errors.street && (
                <p className="p-errors">{errors.street.message}</p>
              )}
            </div>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default ShipInfo;
